import React from 'react';
import classNames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { LogoImage } from './logo-image';

const getStyles = () => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '165px',
  },
  logo: {
    width: '182px',
    flex: '0 0 auto',
  },
});

export const Branding = () => {
  const classes = useDefaultStyles(getStyles);

  return (
    <div className={classNames(classes.container, 'branding')}>
      <LogoImage className={classNames(classes.logo, 'ms-logo-image')} />
    </div>
  );
};
